import { useEffect, useState } from 'react';

const SUB_INDEX_LABELS = {
  corridor_infrastructure: 'Corridor & Infrastructure',
  proximity_attractor: 'Proximity & Attractor',
  incident_signal: 'Incident Signal'
};

export default function SubScoreBars({ subScores }) {
  if (!subScores) return null;

  return (
    <div className="space-y-3">
      {Object.entries(subScores).map(([key, sub], i) => (
        <SubScoreBar
          key={key}
          label={SUB_INDEX_LABELS[key] || key}
          score={sub?.score ?? 0}
          deduction={sub?.deduction ?? 0}
          max={sub?.max_deduction ?? 100}
          coverageGaps={sub?.coverage_gaps || []}
          animationDelay={i * 0.15}
        />
      ))}
    </div>
  );
}

function SubScoreBar({ label, score, deduction, max, coverageGaps, animationDelay }) {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setWidth(score), 200 + animationDelay * 1000);
    return () => clearTimeout(timer);
  }, [score, animationDelay]);

  // Color based on this sub-score's value
  const color = score >= 85 ? '#22C55E'
              : score >= 70 ? '#84CC16'
              : score >= 55 ? '#F59E0B'
              : score >= 35 ? '#EF4444'
              : '#991B1B';

  return (
    <div>
      <div className="flex items-baseline justify-between mb-1">
        <div className="text-sm font-semibold text-navy">{label}</div>
        <div className="text-sm font-heading font-bold" style={{ color }}>
          {score}<span className="text-xs text-gray-400 font-sans font-normal">/100</span>
        </div>
      </div>
      <div className="h-3 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-1000 ease-out"
          style={{
            width: `${width}%`,
            backgroundColor: color,
            transitionDelay: `${animationDelay}s`
          }}
        />
      </div>
      {coverageGaps && coverageGaps.length > 0 && (
        <div className="text-[10px] text-gray-400 italic mt-1">
          Limited coverage: {coverageGaps.join(', ')} unavailable for this location
        </div>
      )}
    </div>
  );
}
